import { useTheme } from 'styled-components'

import { FormikTextArea } from '@/@bothrs-ui/web/components/forms/text-area/FormikTextArea'
import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

// ================================ Component ================================

type StructuredObservationFreeInputProps = {
  fieldName: string
  label: string
  placeholder: string
  maxLength?: number
  minHeight: number
}

export const StructuredObservationFreeInput = ({
  fieldName,
  label,
  placeholder,
  maxLength = 500,
  minHeight,
}: StructuredObservationFreeInputProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space4} flexGrow={1} style={{ minHeight }}>
      <Span type='BodyLabel' color={theme.Colors.Neutrals.Darkest} style={{ textTransform: 'uppercase' }}>
        {label}
      </Span>
      <FormikTextArea
        name={fieldName}
        rows={2}
        maxLength={maxLength}
        data-1p-ignore
        autoComplete='off'
        placeholder={placeholder}
        noMargin
        autoGrow
        maxHeight={minHeight - 40}
        style={{ fontSize: 16 }}
      />
    </FlexColumn>
  )
}
